export const code = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/
